/* eslint-disable no-param-reassign,class-methods-use-this */
import i18next from "i18next";

export default {
  install(Vue) {
    Vue.t = (...args) => i18next.t(...args);
    Vue.prototype.$t = (...args) => i18next.t(...args);
  }
};
